import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';

export const StatNumber = styled(Text).attrs({
  opacity: 'medium',
})`
  font-size: ${props => props.theme.fontSizes[400]};
  ${props => props.theme.media.small`
    font-size: 20px;
  `}
`;

export const UnitTime = styled(Text).attrs({
  textStyle: 'paragraph400',
  margin: { left: '4px' },
  opacity: 'medium',
})`
  ${props => props.theme.media.small`
    margin: 0;
  `}
`;
